import React from 'react';
import {HeroContainer, HeroContent, HeroH1, HeroP} from './HeroElement';
import videoHero from "../../assets/movies/sphere_v02_black.webm";

const HeroSection3 = ({categoryName}) => {
  return (
    <HeroContainer>
      <video id="bg-video" autoPlay loop muted>
        <source src={videoHero} type="video/mp4"/>
      </video>
      <HeroContent style={{top: "25%", alignItems: "start"}}>
        <HeroH1>{categoryName}</HeroH1>
        <HeroH1>ALL the WAy To tHE NFTs in the MeTAVeRSe Pop BeLLY NFT Collection</HeroH1>
        <HeroP>
          Heroes, villains, innovators, leaders, role models – these are just some of the different
          types of people that have graced our world. This NFT collection offers a wide variety of
          iconic individuals who have been extremely relevant in the world. Now you can own one of them in the form of
          very appealing NFT artwork.
        </HeroP>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection3;